import { gql } from "@apollo/client";

const GET_DASHBOARD_STATS = gql`
  query getDashboardStats($filters: DashboardStatsFilter) {
    getDashboardStats(filters: $filters) {
      Status
      Message
      Data {
        ActiveProviders
        NonActiveProviders
        Payers
        Patients
        ActiveUsers
        InactiveUsers
        ActiveEligibility
        NotActiveEligibility
        AcceptedClaims
        PartialClaims
        RejectedClaims
        PendingClaims
        AcceptedPreAuth
        PartialPreAuth
        RejectedPreAuth
        PendingPreAuth
      }
    }
  }
`;

const DASHBOARD_STATS = gql`
  query getDashboardStats($filters: DashboardStatsFilterInput) {
    getDashboardStats(filters: $filters) {
      status
      message
      data {
        patients
        total_claims
        total_verification
        active_verification
        not_active_verification
        total_pre_auth
        pre_auth_breakdown {
          type
          total
          approved
          pending
          rejected
          cancelled
          partial
          errored
        }
        verification_payer_breakdown {
          payer_id
          payer_name
          total
          active
          not_active
          active_rate
        }
        claims_status_breakdown {
          total_count
          accepted {
            count
          }
          pending {
            count
          }
          rejected {
            count
          }
          partial {
            count
          }
          cancelled {
            count
          }
          errored {
            count
          }
        }
        claims_rejection_reasons {
          reason
          count
          percentage
        }
      }
    }
  }
`;

const DASHBOARD_ELIGIBILITY = gql`
  query getDashboardEligibility($filters: DashboardStatsFilterInput) {
    getDashboardEligibility(filters: $filters) {
      status
      message
      data {
        patients
        total_verification
        active_verification
        not_active_verification
        verification_payer_breakdown {
          payer_id
          payer_name
          total
          active
          not_active
          active_rate
        }
      }
    }
  }
`;

const DASHBOARD_CLAIMS = gql`
  query getDashboardClaims($filters: DashboardStatsFilterInput) {
    getDashboardClaims(filters: $filters) {
      status
      message
      data {
        total_claims
        claims_status_breakdown {
          total_count
          accepted {
            count
          }
          pending {
            count
          }
          rejected {
            count
          }
          partial {
            count
          }
          cancelled {
            count
          }
          errored {
            count
          }
        }
        claims_rejection_reasons {
          reason
          count
          percentage
        }
      }
    }
  }
`;

const DASHBOARD_PRE_AUTH = gql`
  query getDashboardPreAuth($filters: DashboardStatsFilterInput) {
    getDashboardPreAuth(filters: $filters) {
      status
      message
      data {
        total_pre_auth
        pre_auth_breakdown {
          type
          total
          approved
          pending
          rejected
          cancelled
          partial
          errored
        }
      }
    }
  }
`;

export default {
  GET_DASHBOARD_STATS,
  DASHBOARD_STATS,
  DASHBOARD_ELIGIBILITY,
  DASHBOARD_CLAIMS,
  DASHBOARD_PRE_AUTH,
};
